import { render, staticRenderFns } from "./UpdateSmsLinkConfig.vue?vue&type=template&id=130ba4f6&scoped=true"
import script from "./UpdateSmsLinkConfig.vue?vue&type=script&lang=js"
export * from "./UpdateSmsLinkConfig.vue?vue&type=script&lang=js"
import style0 from "./UpdateSmsLinkConfig.vue?vue&type=style&index=0&id=130ba4f6&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "130ba4f6",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/gitlab-runner/builds/VsAMsifqL/0/hero/frontend/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('130ba4f6')) {
      api.createRecord('130ba4f6', component.options)
    } else {
      api.reload('130ba4f6', component.options)
    }
    module.hot.accept("./UpdateSmsLinkConfig.vue?vue&type=template&id=130ba4f6&scoped=true", function () {
      api.rerender('130ba4f6', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/brandname/UpdateSmsLinkConfig.vue"
export default component.exports